import { createContext, useState } from "react";

export const InventoryManagementContext = createContext();

export const InventoryManagementContextProvider = ({ children }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);

    const contextValue = {
        selectedProducts,
        setSelectedProducts,
    };

    return (
        <InventoryManagementContext.Provider value={ contextValue }>
            { children }
        </InventoryManagementContext.Provider>
    );
}
